import Course from "../types/Course";
import {FCWithHTMLAttributes} from "../types/reactTypes";
import clsMerge from "../util/clsMerge";
import CourseButton from "./CourseButton";

const CourseButtonGrid: FCWithHTMLAttributes<{courses: Course[]}> = ({
	courses,
	className,
}) => {
	return (
		<div
			className={clsMerge("grid grid-cols-1 gap-4 md:grid-cols-2", className)}
		>
			{courses.map((course) => (
				<CourseButton course={course} key={course.courseId} />
			))}
		</div>
	);
};

export default CourseButtonGrid;
